import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ChevronV2 } from 'assets/icons/ChevronV2'
import { Button } from 'components/ui/Button/Button'
import { CoreStatePill, SourceBadge } from 'pages/Operations/Shared/OpsSharedComponents'
import { etaLabel, taskCoreState } from 'pages/Operations/Shared/opsControl'
import { ITaskQueueCardProps } from 'types/departmentBoard.interface'
import {
  ActionsRow,
  BlockedReasonText,
  ChevronWrap,
  DetailCell,
  DetailGrid,
  DetailLabel,
  DetailValue,
  TaskBody,
  TaskCard,
  TaskCardHead,
  TaskMeta,
  TaskName,
  TaskTitleWrap,
  TaskTopRow,
  UnassignedBadge,
} from './DepartmentBoard.styled'

export const TaskQueueCard = ({ task, expanded, onToggle }: ITaskQueueCardProps) => {
  const navigate = useNavigate()
  return (
    <TaskCard $blocked={!!task.blockedReason}>
      <TaskCardHead onClick={onToggle}>
        <TaskTitleWrap>
          <TaskTopRow>
            <TaskName>{task.name}</TaskName>
            <CoreStatePill state={taskCoreState(task.taskStatus)} context='task' />
            <SourceBadge source={task.source} />
          </TaskTopRow>
          <TaskMeta>
            {task.location} · ETA {etaLabel(task.etaMin)}
          </TaskMeta>
          {task.unassignedReason && <UnassignedBadge>Unassigned — {task.unassignedReason}</UnassignedBadge>}
          {task.blockedReason && <BlockedReasonText>{task.blockedReason}</BlockedReasonText>}
        </TaskTitleWrap>
        <ChevronWrap $open={expanded}>
          <ChevronV2 open={expanded} />
        </ChevronWrap>
      </TaskCardHead>
      {expanded && (
        <TaskBody>
          <DetailGrid>
            <DetailCell>
              <DetailLabel>Operator</DetailLabel>
              <DetailValue>{task.operator ?? '—'}</DetailValue>
            </DetailCell>
            <DetailCell>
              <DetailLabel>Machine</DetailLabel>
              <DetailValue>{task.machine ?? '—'}</DetailValue>
            </DetailCell>
            <DetailCell>
              <DetailLabel>Created at</DetailLabel>
              <DetailValue>{task.generatedAt}</DetailValue>
            </DetailCell>
            <DetailCell>
              <DetailLabel>Came from</DetailLabel>
              <DetailValue>{task.sourceName ?? '—'}</DetailValue>
            </DetailCell>
          </DetailGrid>
          <ActionsRow>
            <Button variant='secondary' size='sm' onClick={() => toast.success('Reassignment request queued')}>
              Reassign
            </Button>
            <Button variant='black' size='sm' onClick={() => toast.success('Priority raise queued')}>
              Raise priority
            </Button>
            <Button variant='black' size='sm' onClick={() => toast.success('Source view queued')}>
              Open source
            </Button>
            <Button variant='black' size='sm' onClick={() => navigate(`/operations/task/${task.id}`)}>
              Open task
            </Button>
          </ActionsRow>
        </TaskBody>
      )}
    </TaskCard>
  )
}
